import Vue from "vue";

const cssEfects = {
  install(Vue) {
    Vue.prototype.$cssEfect = {
      htmlScroll: function (val) {
        const htmlElement = document.getElementsByTagName("html")[0];
        if (htmlElement) {
          if (val) {
            htmlElement.style.overflow = "auto"; // Use 'auto' instead of 'scroll' to show scrollbar only when needed
          } else {
            htmlElement.style.overflow = "hidden";
          }
        }
      },
    };
  },
};
Vue.use(cssEfects);
